import { PointVideoHistoryQuerySort, usePointVideoHistoryQuery } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';
import { useState } from 'react';

const PAGE_SIZE = 50;

const useVideoHistory = (pointId: string, dateFrom: string, dateTo: string) => {
  const [page, setPage] = useState(0);
  const { data, loading, error, refetch, fetchMore } = usePointVideoHistoryQuery({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
    skip: !pointId || !dateFrom || !dateTo,
    variables: {
      filters: { pointId, onAirRange: { dateFrom, dateTo } },
      pagination: { page: 0, pageSize: PAGE_SIZE },
      sort: PointVideoHistoryQuerySort.OnAirDesc,
    },
  });

  const fetchMoreVideoHistory = () => {
    if (!data?.pointVideoHistoryPaginationQuery.paginationInfo.hasNextPage) return;
    fetchMore({
      updateQuery: (prev, { fetchMoreResult }) => {
        setPage(fetchMoreResult.pointVideoHistoryPaginationQuery.paginationInfo.page);
        const data = {
          ...prev,
          pointVideoHistoryPaginationQuery: {
            ...prev?.pointVideoHistoryPaginationQuery,
            ...fetchMoreResult?.pointVideoHistoryPaginationQuery,
            result: [
              ...(prev?.pointVideoHistoryPaginationQuery?.result || []),
              ...(fetchMoreResult?.pointVideoHistoryPaginationQuery?.result || []),
            ],
            paginationInfo: {
              ...prev.pointVideoHistoryPaginationQuery.paginationInfo,
              ...fetchMoreResult.pointVideoHistoryPaginationQuery.paginationInfo,
            },
          },
        };

        return data;
      },
      variables: {
        pagination: { page: page + 1, pageSize: data.pointVideoHistoryPaginationQuery.paginationInfo.pageSize },
      },
    });
  };

  return {
    error,
    loading,
    fetchMoreVideoHistory,
    refetch,
    videoHistory: data?.pointVideoHistoryPaginationQuery.result,
    videoHistoryPaginationInfo: data?.pointVideoHistoryPaginationQuery.paginationInfo,
  };
};

export default useVideoHistory;
